import UsersListRow from "./UsersListRow";
import { ip } from '../../../config';
import { useState } from "react";
import { useEffect } from "react";
import { ThreeDots } from 'react-loader-spinner'



const UsersList = () => {

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading("loading");
        fetch(ip + "/users")
            .then(response => response.json())
            .then(data => {
                setUsers(data);
                setLoading("loaded");
            });

    }, [])

    return (
        <>


            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">#ID</th>
                        <th scope="col">Name</th>
                        <th scope="col">Username</th>
                        <th scope="col">Role</th>                        
                    </tr>
                </thead>
                <tbody>
                    {users && <UsersListRow users={users} />}
                </tbody>
            </table>

            <div className="d-flex align-items-center justify-content-center">
                {loading === "loading" && <ThreeDots height="100" width="100" color='grey' ariaLabel='loading' />}

            </div>
        </>
    );
}

export default UsersList;